import React from 'react';
import { Box, Container, Divider } from '@hover/blueprint';
import { HOW_HOVER_WORKS_LIST_DATA } from '../../../constants';
import { SwitcherMobileAndTabletItem } from '../../common';

interface Props {
  currentTab: number;
  setCurrentTab: (tabId: number) => void;
}

const MobileAndTablet: React.FC<Props> = ({ currentTab, setCurrentTab }) => (
  <Container
    maxW="100%"
    px={0}
    centerContent
    d={{ base: 'flex', desktop: 'none' }}
  >
    <Box w="100%" h="1px" id="how-does-it-works-sign" />
    <Divider
      borderColor="red.100"
      borderWidth="1px"
      borderTopWidth={0}
      my={0}
      d={currentTab === 0 ? 'none' : 'block'}
    />
    {HOW_HOVER_WORKS_LIST_DATA.map(listItem => (
      <SwitcherMobileAndTabletItem
        key={listItem.id}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        itemId={listItem.id}
        borderColor="red.100"
        activeBackground="red.100"
        title={listItem.title}
        titleColor="red.500"
        isLast={listItem.id === HOW_HOVER_WORKS_LIST_DATA.length - 1}
        body={listItem.body}
      >
        <Box
          mt={600}
          d={listItem.id === currentTab ? 'flex' : 'none'}
          alignItems="center"
          justifyContent="center"
          w="100%"
          px={500}
          maxH="355px"
        >
          <Box maxH="355px" minH={{ base: 'auto', tablet: '355px' }}>
            {listItem.mobileImage}
          </Box>
        </Box>
      </SwitcherMobileAndTabletItem>
    ))}
  </Container>
);

export default MobileAndTablet;
